// extracted by mini-css-extract-plugin
export default {"inactive":"alert-overview-toggle_inactive__8UEmR"};